import moment from "moment";
import { takeEvery, call, put, all, select } from "redux-saga/effects";
import { buildGETUrl } from "../../utilities/buildGETUrl";
import { LOAD_TRACKS, loading, putTracks } from "../../store/Tracks/actions";
import { showAlertError, showAlertInfo } from "../../store/Alert/actions";
import axios from "axios";
import { changeValue } from "../../store/Search/actions";

export default function* () {
  yield takeEvery(LOAD_TRACKS, worker);
}

function* worker({ payload }) {
  const theme = payload && payload.theme ? payload.theme : false;
  const outdatedLoaded = yield select((state) => state.tracks.outdatedLoaded);

  if (payload && (payload.outdate || !payload?.id) && outdatedLoaded) return;

  console.log(LOAD_TRACKS, { payload }, payload?.outdate, !!outdatedLoaded);

  const outdate = payload?.outdate;

  yield put(loading(true));
  try {
    let tracks = [],
      tracksAssoc = {};

    if ((!outdate || payload?.outdate === "false") && !theme && !payload.id) {
      if (outdatedLoaded) return;
      payload.outdate = "false";
    }

    const fetchedTracks = yield call(fetchTracks, payload);

    if (fetchedTracks.error) {
      yield put(
        showAlertError({
          errors: [`Ошибка сервера при ${LOAD_TRACKS}.`, fetchedTracks],
          text: "Ролики не были загружены. Попробуйте перезагрузить страницу.",
        })
      );
      yield put(putTracks({ tracks, tracksAssoc }));
    } else {
      const ft = fetchedTracks.success;

      if (ft.warning) {
        yield put(
          showAlertInfo({
            text: ft.warning,
          })
        );
      }

      console.log({ ft });

      //  Array.isArray(fetchedTracks.success) ? fetchedTracks.success : Object.values(fetchedTracks.success)

      if (ft[0]) {
        // const today = Number(moment(new Date()).format("x"))
        // const clips = yield all(
        //     ft.map(track => call(fetchClips, track.id))
        // )

        ft.map((track, index) => {
          track.ctime_d = moment(track.mtime).format("DD.MM.Y");
          track.ctime_t = moment(track.mtime).format("HH:m:s");
          track.clipEnded = track.outdate;
          track.clipDeleted = track.deleted || false;
          
          // Иконка
          if (track.clipEnded || track.clipDeleted) {
            track.trackWarning = true;
          }

          // Ссылка на файл
          track.filename = buildGETUrl("clip/play", { id: track.id });

          tracks.push(track);
          tracksAssoc[track.id] = track;
        });

        console.log({ tracks });

        if (payload?.id) {
          const tracks_list = yield select((state) => state.tracks.tracks);
          console.log({ tracks_list });

          tracks = tracks_list.map((el) =>
            payload.id.indexOf(el.id) !== -1 ? tracksAssoc[el.id] : el
          );
          const tracksAssoc_old = yield select(
            (state) => state.tracks.tracksAssoc
          );
          tracksAssoc = { ...tracksAssoc_old, ...tracksAssoc };
        }

        console.log({ tracks });

        if (outdate === "true") {
          const tracks_list = yield select((state) => state.tracks.tracks);

          tracks = [...tracks_list, ...tracks].sort((a, b) => b.id - a.id);
        }

        console.log({ tracks });
      } else {
        tracks = ft;
      }

      // tracks.map(track => tracksAssoc[track.id] = track)
      console.log({ tracks });

      yield put(
        putTracks({
          tracks,
          tracksAssoc,
          theme,
          ...(outdate === "true" ? { outdate: true } : {}),
        })
      );

      // const value = yield select(state => state.search.tracks.value)
      // yield put(changeValue({
      //     type: 'tracks',
      //     value
      // }))
    }
  } catch (e) {
    console.error({ e });

    yield put(
      showAlertError({
        errors: [`Ошибка сети при ${LOAD_TRACKS}.`, e],
        text: "Ролики не были загружены. Попробуйте перезагрузить страницу.",
      })
    );
    yield put(putTracks({ tracks: [], tracksAssoc: {} }));
  } finally {
    yield put(loading(false));
  }
}

function fetchTracks(paramsInner) {
  let params = { ...paramsInner };
  let link = "/clip/select";

  if (params && params.theme) {
    params["owner_id"] = "";
    if (params.theme === "extra") {
      link = "/clip/extra/select";
    }
  }

  console.log({ params });

  delete params.theme;
  delete params.callback;

  return axios.get(link, { params }).then((response) => response.data);
}

function fetchTracksExtra(params) {
  const getParams = { owner_id: "" };

  return axios
    .get("/clip/extra/select", { params: getParams })
    .then((response) => response.data);
}

function fetchClips(trackId) {
  return axios
    .get("/timeline/clip/select", {
      params: { indent_id: trackId },
    })
    .then((response) => response.data);
}
